import { ValueOf } from '../utilities/types';

const agentModes = {
  CREATE: 'create',
  EDIT: 'edit',
  FETCHING: 'fetching',
  LOADING: 'loading',
  VIEW: 'view',
};

export type AgentMode = ValueOf<typeof agentModes>;

export default agentModes;
